import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { loadCountryMeta, type CountryMetaMap, type CountryMetaRow } from '../api/countries'

// Hook returning a code → {name, networks, flag} map for the current
// i18n language. Falls back to whatever the caller already has from
// catalog.ts while the fetch is in flight.
export function useCountriesMeta(): CountryMetaMap | null {
  const { i18n } = useTranslation()
  const lang = (i18n.language || 'en').split('-')[0]
  const [data, setData] = useState<CountryMetaMap | null>(null)

  useEffect(() => {
    let cancelled = false
    loadCountryMeta(lang)
      .then((map) => {
        if (!cancelled) setData(map)
      })
      .catch(() => {
        if (!cancelled) setData(null)
      })
    return () => {
      cancelled = true
    }
  }, [lang])

  return data
}

// Convenience: fetch one row by code, returning a stable shape with
// caller-supplied fallbacks while the network is loading.
export function pickMeta(
  map: CountryMetaMap | null,
  code: string,
  fallback: { name: string; flag: string; networks: string },
): CountryMetaRow {
  if (map && map[code]) return map[code]
  return { code, ...fallback }
}
